import React from "react";
import RoadmapHero from "../../Components/RoadmapHero/RoadmapHero";
const Roadmap = () => {
    return (
        <div className="roadmap">
            <RoadmapHero />
        </div>
    )
}
export default Roadmap;